export default "<p>mailer-view works!</p>\n"